import type { TaskResult } from "../types";

export async function gradeProject20(): Promise<TaskResult[]> {
  const results: TaskResult[] = [];

  // Tarea 2: Verificar que el título del documento sea "Nuevas tarifas"
  try {
    await Excel.run(async (context) => {
      const props = context.workbook.properties;
      props.load("title");
      await context.sync();

      const title = String(props.title ?? "").trim();
      results.push({
        taskId: 2,
        passed: title.toLowerCase() === "nuevas tarifas",
      });
    });
  } catch {
    results.push({ taskId: 2, passed: false });
  }

  // Tarea 3: Verificar área de impresión A1:F10
  try {
    await Excel.run(async (context) => {
      const sheet = context.workbook.worksheets.getItem("Salas");
      const printArea = sheet.pageLayout.getPrintAreaOrNullObject();
      printArea.load("address");
      await context.sync();

      const address = String(printArea.isNullObject ? "" : printArea.address)
        .replace(/\$/g, "")
        .toUpperCase();
      results.push({ taskId: 3, passed: address.includes("A1:F10") });
    });
  } catch {
    results.push({ taskId: 3, passed: false });
  }

  try {
    await Excel.run(async (context) => {
      const sheet = context.workbook.worksheets.getItem("Salas");
      const row = sheet.getRange("2:2");
      row.format.load("wrapText");
      await context.sync();

      results.push({ taskId: 5, passed: row.format.wrapText === true });
    });
  } catch {
    results.push({ taskId: 5, passed: false });
  }

  return results;
}
